module.exports = __webpack_public_path__ + "static/media/Dual_Reflect_3111.03b178c7.jpg";